import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ChangePasswordCard } from "@/components/account/ChangePasswordCard";

export function PlatformProfile() {
  const { user, setUser } = useAuth();
  const [v, setV] = useState({ name: user?.name || "", phone: user?.phone || "" });
  if (!user) return null;
  const save = async (e) => {
    e.preventDefault();
    try { setUser((await api.put("/auth/me", v)).data); toast.success("Profile updated"); } catch (err) { toast.error(formatErr(err)); }
  };
  return (
    <div className="grid max-w-5xl gap-6 md:grid-cols-2" data-testid="platform-profile">
      <form onSubmit={save} className="card-surface space-y-4 p-6" data-testid="platform-profile-form">
        <h3 className="text-xl font-bold uppercase text-white">My profile</h3>
        <div className="space-y-1.5"><Label>Email</Label><Input value={user.email} disabled data-testid="platform-profile-email" /></div>
        <div className="space-y-1.5"><Label>Name</Label><Input value={v.name} onChange={(e) => setV({ ...v, name: e.target.value })} minLength={2} required data-testid="platform-profile-name" /></div>
        <div className="space-y-1.5"><Label>Phone</Label><Input value={v.phone} onChange={(e) => setV({ ...v, phone: e.target.value })} minLength={7} required data-testid="platform-profile-phone" /></div>
        <Button type="submit" className="rounded-full" data-testid="platform-profile-save">Save profile</Button>
      </form>
      <ChangePasswordCard />
    </div>
  );
}
